import Vue from 'vue'
import Unicon from 'vue-unicons/dist/vue-unicons-vue2.umd'

import { uniEnvelope, uniCalendarAlt, uniUser, uniCircle, uniEllipsisV, uniAngleLeftB, uniAngleRightB, uniEdit, uniFileQuestionAlt } from 'vue-unicons/dist/icons'

Unicon.add([uniEnvelope, uniCalendarAlt, uniUser, uniCircle, uniEllipsisV, uniAngleLeftB, uniAngleRightB, uniEdit, uniFileQuestionAlt])

Vue.use(Unicon)